export default __webpack_public_path__ + "static/media/French.272ebb8b.mp3";